var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.localVisible,"title":_vm.$t('平台退款单'),"width":800,"footer":null},on:{"cancel":_vm.onCancel}},[_c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.orders,"pagination":false,"bordered":"","size":"middle","rowKey":"platformRefundOrderId","scroll":{ x: 700 }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }